export default "__VITE_ASSET__Q8BfJSnL__"